export const isSecondary = (v: number) => (v & 0x80) !== 0;
export const toPrimaryIndex = (v: number) => v & 0x0f;          // 0..15
export const asSecondary = (base: number) => (base & 0x0f) | 0x80; // 128..143

// PICO-8-färger (PRIMARY = befintliga props.colors, SECONDARY nedan)
export const PICO8_SECONDARY: string[] = [
  '#291814','#111D35','#422136','#125359','#742F29','#49333B','#A28879','#F3EF7D',
  '#BE1250','#FF6C24','#A8E72E','#00B543','#065AB5','#754665','#FF6E59','#FF9D81'
];